<template>
    <div class="content">
        <div class="d_box">
            <van-cell-group class="w50 row flex-wrap">
                <van-field label-width="4em" v-model="form.shopName" label="就职门店" placeholder="就职门店" readonly @click="showshop = true"/>
                <van-field label-width="4em" v-model="form.jobTypeName" label="工作类型" placeholder="工作类型" readonly @click="gettype('jobType')"/>
                <van-field label-width="4em" v-model="form.brandName" label="品牌" placeholder="品牌" clearable />
                <van-field label-width="4em" v-model="form.queryTime" label="时间" placeholder="时间" readonly @click="showtime = true"/>
                <van-field label-width="4em" v-model="form.mobile" label="手机号" placeholder="手机号" clearable />
                <van-field label-width="4em" v-model="form.statusName" label="状态" placeholder="状态" readonly @click="gettype('status')"/>
            </van-cell-group>
            <div class="center">
                <van-button type="info" size="small" @click="submit()">查询</van-button>
            </div>
        </div>
        <div class="d_box row flex-wrap" style="padding: 5px 0;">
            <div class="item">商户员工：在职{{merchantEmployees}}人</div>
            <div class="item">三方公司：在职{{threePartyCompany}}人</div>
            <div class="item">外保：在职{{outsiders}}人</div>
            <div class="item">合计：在职{{total}}人</div>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="onLoad">
                <div class="d_box d_auto">
                    <div class="otem row">
                        <div class="num"></div>
                        <div class="name">姓名</div>
                        <div class="age">年龄</div>
                        <div class="nativePlace">籍贯</div>
                        <div class="idCard">身份证号</div>
                        <div class="state">在职状态</div>
                    </div>
                    <div class="otem row" v-for="(item,index) in list" :key="index">
                        <div class="num">{{index+1}}</div>
                        <div class="name name1" @click="godetail(item)">{{item.realName}}</div>
                        <div class="age">{{item.birthday!=''?getages1(item.birthday):item.idCardType==1?getages(item.idCard):''}}</div>
                        <div class="nativePlace">{{item.nativePlace}}</div>
                        <div class="idCard">{{item.idCardNo}}</div>
                        <div class="state">{{item.ledgerShopList.length>0 && item.ledgerShopList[0].cancelCardTime!='' && item.ledgerShopList[0].cancelCardTime!=null?"离职":"在职"}}</div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
        
        <van-calendar color="#6236FF" :min-date="minDate" v-model="showtime" @confirm="onConfirm" />
        <van-popup v-model="showtype" position="bottom">
            <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onpicker"
                @cancel="showtype = false"/>
        </van-popup>
        <van-action-sheet v-model="showshop" title="请选择门店">
            <van-search v-model="keyword" show-action placeholder="请输入搜索关键词" @search="onSearch" @cancel="onCancel" />
            <div class="scroll">
                <van-cell-group>
                    <van-cell title="全部" @click="getval({value:'',name:'全部'})"/>
                    <van-cell v-for="(item,index) in showlist" :key="index" :title="item.name" @click="getval(item)"/>
                </van-cell-group>
            </div>
        </van-action-sheet>
    </div>
    
</template>

<script>
import moment from 'moment'
export default {
  name: 'ledger',
  data () {
    return{
        token:this.$route.params.token,
        //token:'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiLmooHlv5flqJ8iLCJsb2dpbkxvY2F0aW9uIjoiMTA2IiwibG9naW5fdXNlcl9rZXkiOiI0YzUwYzVhZS00MDIzLTQzOWYtYjViYi00Y2EwZWVlMDQ2OGEifQ.ojA-bTWooVMpTb5BX5hQW75P6kttJu8EcdkT7FvM4t25ttUbFj63Sb126I0RhFibkEEe6Xr-A70kdRD1dp4oYw',
        form:{
            pageNo:1,
            pageSize:10,
            jobType:'',
            brandSid:'',
            brandName:'',
            mobile:'',
            queryTime:'',
            shopSid:'',
            status:'',
            jobTypeName:'全部',
            statusName:'全部',
            shopName:'全部',
        },
        threePartyCompany:0,
        merchantEmployees:0,
        outsiders:0,
        total:0,
        list:[],
        loading: false,
        finished: false,
        totalnum:0,
        showtime:false,
        showtype:false,
        showshop:false,
        type:'',
        joblist:['全部','商户员工','外保人员','三方公司员工'],
        statlist:['全部','离职','在职'],
        columns:[],
        shoplist:[],
        showlist:[],
        minDate: new Date(2010, 0, 1),
        keyword:'',
        refreshing:false,
    }
  },
  created(){
    document.title ='门店人员台账'
    this.getshop()
    this.getnum()
    this.getlist()
    // this.onLoad()
  },
  methods:{
    onConfirm(date) {
      this.showtime = false;
      this.form.queryTime = moment(date).format('YYYY-MM-DD');
    },
    onpicker(index){
        let nindex = this.columns.findIndex(item => item == index)
        if(this.type=='jobType'){
            this.form.jobType=nindex==0?'':nindex
            this.form.jobTypeName=index
        }else{
            this.form.status=nindex==0?'':nindex-1
            this.form.statusName=index
        }
        this.showtype=false
    },
    gettype(type){
        this.columns=type=='jobType'?this.joblist:this.statlist
        this.type=type
        this.showtype=true
    },
    removeProperty (obj) {
        Object.keys(obj).forEach(item => {
            if (obj[item] === '' || obj[item] === [] || obj[item] === {} || obj[item] === undefined || obj[item] === null || obj[item] === 'null') delete obj[item]
        })
            return obj
    },
    getval(item){ 
        console.log(item)
        this.form.shopSid=item.value
        this.form.shopName=item.name
        this.showshop=false
    },
    onCancel(){

    },
    onSearch(){
        console.log(this.keyword)
        let alllist=JSON.parse(JSON.stringify(this.shoplist))
        this.showlist=alllist.filter(item => item.name.includes(this.keyword))
    },
    getshop(){
      let that=this;
      that.$axios.get(process.env.API_HOST+"api/vue/mainData/shop/getAllShopList",'').then((res) => {
        if(res.status==200){
          that.shoplist=res.data.shopList
          if(res.data.shopList.length>0){
            let index = res.data.shopList.findIndex(item => item.value === '100')
            if(index>-1){
              that.shoplist.splice(index, 1)
            }
          }
          that.showlist=that.shoplist
        }
      }).catch((error) =>{
      });

    },
    getnum(){
        let that = this
        let form=JSON.parse(JSON.stringify(this.form))
        form.pageNo=1
        // form.jobType=''
        that.$axios.post(process.env.API_HOST+"sysmanager/applets/ledger/num",this.removeProperty(form),{
            headers:{
                userTicket:that.token
            }
        }).then((res) => {
            if(res.data.state==200){
                let data=res.data.data
                that.threePartyCompany=data.threePartyCompany || 0
                that.merchantEmployees=data.merchantEmployees || 0
                that.outsiders=data.outsiders || 0
                that.total=data.total || 0
            }else {
                that.$toast(res.data.message)
            }
        })		
    },
    onRefresh(){
        this.form.pageNo=1
        this.getlist()
    },
    onLoad() {
        this.form.pageNo++
        this.getlist()
        // this.loading = false;
        // console.log(this.form.pageNo>0 && this.list.length == this.totalnum,this.list.length,this.totalnum)
        // if (this.form.pageNo>0 && this.list.length == this.totalnum && !this.finished) {
        //     this.finished = true;
        // }else{
        //     this.form.pageNo++
        //     this.getlist()
        // }
    },
    submit(){
        this.form.pageNo=0
        this.getnum()
        this.onLoad()
    },
    getlist(){
        let that = this
        that.$axios.post(process.env.API_HOST+"sysmanager/applets/ledger/page",that.removeProperty(that.form),{
            headers:{
                userTicket:that.token
            }
        }).then((res) => {
            if(res.data.state==200){
                that.loading=false
                if (that.refreshing) {
                    that.list = [];
                    that.refreshing = false;
                }
                if (that.form.pageNo == 1) {
                   that.list=res.data.data.list || []
                } else {
                    that.list = [...that.list, ...res.data.data.list]
                }
                if (that.list.length == res.data.data.total) {
                    that.finished = true
                } else {
                    that.finished = false
                }

                // if(that.form.pageNo==1){
                //     that.list=res.data.data.list || []
                // }else{
                //     let list=res.data.data.list || []
                //     that.list=[...that.list,...list]
                // }
                that.totalnum=res.data.data.total || 0
            }else {
                that.$toast(res.data.message)
            }
        })			
    },
    getages(id){
      let myDate = new Date(); 
      let age = myDate.getFullYear() - id.substring(6, 10); 
      return age
    },
    getages1(id){
      let myDate = new Date(); 
      let age = myDate.getFullYear() - moment(id).format('YYYY'); 
      return age
    },
    godetail(row){
        this.$router.push({name: 'ledgerdetail', params: {id: row.sid}})
    },
  }
}
</script>

<style scoped>

.content{
    margin: 0.2rem auto 0;
    border-radius: 0.2rem;
    box-sizing: border-box;
    padding: 0.2rem 0.4rem 0;
}
.row{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.flex-wrap{
    flex-wrap: wrap;
}
.d_box{
    width: 100%;
    margin-top: 0.2rem;
    border-radius: 0.2rem;
    box-sizing: border-box;
    background: #E8EBEF;
    overflow: hidden;
    font-size: 14px;
}
.d_box .title{
    position: relative;
    font-size: 0.42rem;
    font-weight: bold;
    border-bottom: 0.02rem solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 0.3rem 0.5rem;
}
.d_box .title::after{
    position: absolute;
    content: "";
    width: 0.12rem;
    height: 0.5rem;
    background: #6236FF;
    left: 0.2rem;
    top: 50%;
    margin-top: -0.25rem;
    border-radius: 0.18rem;
}
.d_box .item{
    width: 50%;
    box-sizing: border-box;
    padding: 0.15rem 0.3rem;
}
.d_auto{
    overflow-x: auto;
    margin-top: 0.3rem;
}
.otem{
    text-align: center;
    width: 14rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 0.3rem 0;
}
.otem .num{
    width: 1.5rem;
}
.otem .name{
    width: 2.5rem;
}
.otem .age{
    width: 1.5rem;
}
.otem .nativePlace{
    width: 2.5rem;
}
.otem .idCard{
    width: 4.5rem;
}
.otem .state{
    width: 2rem;
}
.d_box >>> .van-cell-group,.d_box >>> .van-cell{
  background: #E8EBEF;
}
.d_box >>> .van-field__label,.d_box >>> .van-field__control{
    color: #303133;
}
.d_box >>> .van-button--small{
    padding: 0 30px;
}
.d_box .li{
    width: 50%;
    padding: 10px 16px 0;
    box-sizing: border-box;
}
.center{
    text-align: center;
    padding: 10px 0;
}
.w50{
    width: 100%;
    font-size: 12px;
}
.w50 >>> .van-cell{
    width: 50%;
    box-sizing: border-box;
}
.w50 >>> .van-cell__value{
    flex: 3;
    background: #fff;
    border-radius: 1px;
    font-size: 12px;
}
.w50 >>>.van-field__label{
    font-size: 12px;
    margin-right: 5px;
}
.name1{
    color: #6236FF;
}
</style>


// WEBPACK FOOTER //
// src/view/ledger.vue